import { put, takeEvery } from "redux-saga/effects";
import { appConfig } from "../../config";
import { toast, Flip } from "react-toastify";
import {
    FETCH_USERS_INIT_ACTION,
    FETCH_USERS_SUCCESS_ACTION,
    FETCH_USERS_FAIL_ACTION,
    CREATE_USER_INIT_ACTION,
    CREATE_USER_SUCCESS_ACTION,
    CREATE_USER_FAIL_ACTION,
    UPDATE_USER_STATUS_INIT_ACTION,
    UPDATE_USER_STATUS_SUCCESS_ACTION,
    UPDATE_USER_STATUS_FAIL_ACTION,
} from "./action";

function* fetchUsers(value) {
    const token = localStorage.getItem("token");
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const orgId = userDetails.orgId;
    const pageno = value.value && value.value.page ? value.value.page : 1;
    const searchKey =
        value.value && value.value.searchKey !== undefined
            ? value.value.searchKey
            : "";
    const limit = 10;

    try {
        const searchQuery = searchKey ? `&search=${encodeURIComponent(searchKey)}` : "";
        const res = yield fetch(
            `${appConfig.ip}/users?orgId=${orgId}&limit=${limit}&page=${pageno}&role=employee${searchQuery}`,
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        if (!res.ok) {
            throw res;
        } else {
            const resJSON = yield res.json();
            yield put({
                type: FETCH_USERS_SUCCESS_ACTION,
                payload: resJSON,
            });
        }
    } catch (err) {
        yield put({
            type: FETCH_USERS_FAIL_ACTION,
            error: err,
        });
    }
}

function* createUser(value) {
    const token = localStorage.getItem("token");
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const distributor =
      userDetails.role === "employee" ? userDetails.distributor : userDetails.id;

    const payload = {
        ...value.value,
        distributor,
        orgId: userDetails.orgId,
        orgName: userDetails.orgName || "",
        role: "employee",
        status: "active",
        ftLogin: true,
        phnCnfrmd: false,
        oprMode: "open",
        credit: false,
        callingCode: "+91",
    };

    try {
        const res = yield fetch(`${appConfig.ip}/users`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(payload),
        });

        if (!res.ok) {
            const errJSON = yield res.json();
            throw errJSON;
        } else {
            const resJSON = yield res.json();
            yield put({
                type: CREATE_USER_SUCCESS_ACTION,
                payload: resJSON,
            });
            yield toast.success("User created successfully", {
                autoClose: 3000,
                transition: Flip,
            });
            // Refresh user list
            yield put({ type: FETCH_USERS_INIT_ACTION });
        }
    } catch (err) {
        yield put({
            type: CREATE_USER_FAIL_ACTION,
            error: err,
        });
        yield toast.error(err.message || "Failed to create user", {
            autoClose: 3000,
            transition: Flip,
        });
    }
}

function* updateUserStatus(value) {
    const token = localStorage.getItem("token");
    const payload = value.value || {};
    const userId = payload.userId;
    const status = payload.status || "suspended";
    const userDetails = payload.user || {};
    const requestBody = {
        status,
    };

    try {
        const res = yield fetch(`${appConfig.ip}/users/changeStatus/${userId}`, {
            method: "PUT",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(requestBody),
        });

        if (!res.ok) {
            const errJSON = yield res.json();
            throw errJSON;
        } else {
            const resJSON = yield res.json();
            yield put({
                type: UPDATE_USER_STATUS_SUCCESS_ACTION,
                payload: resJSON,
            });
            yield toast.success(`User ${status === "active" ? "activated" : "suspended"} successfully`, {
                autoClose: 3000,
                transition: Flip,
            });
            yield put({
                type: FETCH_USERS_INIT_ACTION,
                value: {
                    page: payload.page || 1,
                    searchKey: payload.searchKey || "",
                },
            });
        }
    } catch (err) {
        yield put({
            type: UPDATE_USER_STATUS_FAIL_ACTION,
            error: err,
        });
        yield toast.error(err.message || "Failed to update user status", {
            autoClose: 3000,
            transition: Flip,
        });
    }
}

export function* UsersActionWatcher() {
    yield takeEvery(FETCH_USERS_INIT_ACTION, fetchUsers);
    yield takeEvery(CREATE_USER_INIT_ACTION, createUser);
    yield takeEvery(UPDATE_USER_STATUS_INIT_ACTION, updateUserStatus);
}
